import { LoadingSpinner } from './LoadingSpinnner';

export default LoadingSpinner;
